export default {
  document: "Document",
  notes: "Notes",
  online_since: "En ligne depuis le",
  file: "Fichier",
  note: "Note",
  delete_document: "Supprimer un document",
  document_remove_confirm: "Êtes-vous sûr de vouloir supprimer ce document ?",
  note_remove_confirm: "Êtes-vous sûr de vouloir supprimer cette note ?",
  document_remove_success: "Votre document a été supprimé avec succès !",
  note_remove_success: "Votre note a été supprimée avec succès !",
  document_remove_error: "Oups, il y'a eu une erreur lors de la suppression",
  document_success: "Votre document a été envoyé avec succès !",
  note_success: "Votre note a été envoyée avec succès !",
  new_doc: "Ajouter un document",
  new_note: "Ajouter une note",
  new_doc_title: "Nouveau document",
  new_note_title: "Nouvelle note",
  file_integrate_learning_book: "Intégrer le fichier (PDF) au contenu du livret d'apprentissage",
  email_notif: "Notification par email",
  notes_summary: "Notes et synthèse",
  by: "Par",
  on: "Le",
  pedagogicDocuments: "Documents pédagogiques",
  generalDocuments: "Documents généraux",
  globalDocuments: "Documents à télécharger",
  otherDocuments: "Autres documents",
  "Documents to download": "Documents à télécharger",
  Watch: "Voir",
  Download: "Télécharger",
  none_document: "Aucun document n'est disponible",
  none_pedagogic: "Aucun document pédagogique n'est disponible",
  none_note: "Aucune note n'est disponible",
};
